import { MANIFEST_IMAGES } from '../manifest/images.js';
import { getSameKeyValueMapForManifest, manifestResolve } from './manifest.utils.js';
import { SwanAssetFolders } from '../types/enums.js';
getSameKeyValueMapForManifest(MANIFEST_IMAGES);

function getSwanImageUrl(key, pathType, swanAssetBaseUrl) {
  return manifestResolve(MANIFEST_IMAGES, key, SwanAssetFolders.IMAGES, pathType, swanAssetBaseUrl);
}

export { getSwanImageUrl };